import { useState } from "react";
import styles from "./SearchBox.module.css";

export default function SearchBox({ onSearch }) {
  const [query, setQuery] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    if (query.trim().length === 0) return;
    onSearch(query);
  }

  return (
    <form className={styles.container} onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Buscar obras, artistas, estilos..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className={styles.input}
      />
    </form>
  );
}
